import { useEffect, useState } from 'react';
import { GeneratorContext } from './GeneratorContext';
import { generateNodes, type NodeRenderers } from './generateNodes';
import type { Screen } from './schema';

interface ScreensRendererProps {
  screens: Screen[];
  renderers: NodeRenderers;
}

export function ScreensRenderer({ screens, renderers }: ScreensRendererProps) {
  const [currentScreenId, setCurrentScreenId] = useState(
    () => screens[0]?.id ?? 'default',
  );

  useEffect(() => {
    setCurrentScreenId(screens[0]?.id ?? 'default');
  }, [screens]);

  const activeScreen = screens.find((s) => s.id === currentScreenId);
  if (!activeScreen) return null;

  return (
    <GeneratorContext.Provider
      value={{ screens, currentScreenId, setCurrentScreenId }}
    >
      {generateNodes({
        nodes: activeScreen.children,
        path: activeScreen.id,
        renderers,
      })}
    </GeneratorContext.Provider>
  );
}
